import { AlertTriangle } from 'lucide-react';

/** Lo que el envío dejó escrito en la aprobación (lote D, A1 y A2). Sin costos ni márgenes: sólo qué filas. */
export interface AvisoDeEnvioGuardado {
  clave: 'sinLinea' | 'costoCero';
  items: Array<{ num: number }>;
}

const filas = (items: Array<{ num: number }>) =>
  `fila${items.length === 1 ? '' : 's'} ${items.map((i) => i.num).join(', ')}`;

/** Las frases para quien firma; vacío si no hay nada que avisar. */
export function textosDeAvisoDeEnvio(avisos: unknown): string[] {
  if (!Array.isArray(avisos)) return [];
  const out: string[] = [];
  for (const a of avisos as AvisoDeEnvioGuardado[]) {
    const n = a?.items?.length ?? 0;
    if (!n) continue;
    const cuantos = n === 1 ? '1 ítem' : `${n} ítems`;
    if (a.clave === 'sinLinea')
      out.push(
        `Esta cotización se envió con ${cuantos} sin línea de negocio (no les aplicó la regla de su línea): ${filas(a.items)}.`
      );
    if (a.clave === 'costoCero')
      out.push(
        `Esta cotización se envió con ${cuantos} con costo 0 (se cotiza${n === 1 ? '' : 'n'} a 0 al cliente): ${filas(a.items)}.`
      );
  }
  return out;
}

/**
 * D11 (16-oct): en la tabla de la bandeja los avisos viajan PLEGADOS (`plegado`: un renglón «Avisos del envío (N)» que
 * se abre con un clic). Desplegados dentro de la columna «Razón» la hacían angosta y la fila crecía a más de 600 px,
 * sacando «Acciones» de la pantalla. En el diálogo de firma y en las fichas siguen a la vista: ahí no falta lugar y
 * quien firma tiene que verlos sin hacer nada.
 */
export function AvisoDeEnvio({ avisos, plegado = false }: { avisos: unknown; plegado?: boolean }) {
  const textos = textosDeAvisoDeEnvio(avisos);
  if (!textos.length) return null;
  if (plegado) {
    return (
      <details
        data-testid="aviso-de-envio"
        data-plegado="true"
        className="mt-1 text-[11px] text-alerta "
      >
        <summary className="flex cursor-pointer list-none items-center gap-1 font-medium">
          <AlertTriangle className="w-3 h-3 shrink-0" />
          <span>
            {textos.length === 1 ? 'Aviso del envío' : `Avisos del envío (${textos.length})`}
          </span>
        </summary>
        <div role="note" className="mt-1 space-y-0.5">
          {textos.map((t) => (
            <p key={t}>{t}</p>
          ))}
        </div>
      </details>
    );
  }
  return (
    <div
      role="note"
      data-testid="aviso-de-envio"
      className="mt-1 space-y-0.5 text-[11px] text-alerta "
    >
      {textos.map((t) => (
        <div key={t} className="flex items-start gap-1">
          <AlertTriangle className="w-3 h-3 mt-[2px] shrink-0" />
          <span>{t}</span>
        </div>
      ))}
    </div>
  );
}
